import React, { useState, useEffect, useRef } from 'react';
import { 
  Users, 
  Shield, 
  Trophy, 
  Settings, 
  Plus, 
  Trash2, 
  Edit2, 
  RefreshCcw, 
  Share2, 
  Check, 
  Menu,
  X,
  ChevronRight,
  ChevronLeft,
  Activity,
  Sparkles,
  Mic2,
  Swords,
  History,
  ListOrdered,
  UserPlus,
  ClipboardList,
  HelpCircle,
  Info,
  ArrowRightLeft,
  Smartphone,
  Download,
  AlertCircle,
  Play,
  Pause,
  RotateCcw,
  MessageCircle,
  Move,
  Globe,
  BarChart3,
  TrendingUp,
  Bot,
  Save,
  Calendar,
  ChevronDown,
  ChevronUp,
  FlaskConical,
  Medal,
  Image as ImageIcon,
  Upload,
  Cloud,
  LogOut,
  Loader2,
  PlayCircle,
  LogIn
} from 'lucide-react';

// --- FIREBASE IMPORTS ---
import { initializeApp } from "firebase/app";
import { 
  getAuth, 
  signInWithCustomToken, 
  signInAnonymously, 
  onAuthStateChanged,
  signOut,
  GoogleAuthProvider, 
  signInWithPopup
} from "firebase/auth";
import { 
  getFirestore, 
  collection, 
  doc, 
  addDoc, 
  setDoc, 
  deleteDoc, 
  updateDoc, 
  onSnapshot, 
  writeBatch
} from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

// --- TRANSLATIONS ---
const TRANSLATIONS = {
  en: {
    appTitle: "FairPlay",
    onboardingTitle: "NO ARGUMENTS.\nJUST FOOTBALL.",
    onboardingSub: "Create perfectly balanced teams in seconds.",
    getStarted: "Continue as Guest", 
    googleLogin: "Sign in with Google",
    rosterTitle: "The Squad",
    addPlayer: "Add Player",
    matchSetup: "Match Setup",
    matchSetupSub: "Who is playing today?",
    settings: "Settings",
    generate: "Generate Teams",
    calculating: "Calculating...",
    resultsTitle: "Fairness Score",
    balanced: "Balanced",
    transferMode: "Transfer Mode",
    transferModeOn: "Transfer Mode ON",
    adjustLineups: "Adjust Lineups / Move",
    matchCentre: "Match Centre",
    homeTeam: "Home Team",
    awayTeam: "Away Team",
    vs: "VS",
    homeWin: "Home Win",
    draw: "Draw",
    awayWin: "Away Win",
    saveMatch: "End & Save Match",
    matchNamePlaceholder: "Match Name (Optional)",
    matchLog: "Match History",
    todaysMatches: "Matches Played Today",
    leaderboard: "Leaderboard",
    rank: "Rank",
    player: "Player",
    ratio: "Win %",
    copy: "Copy",
    whatsapp: "WhatsApp",
    install: "Install App",
    hideRatings: "Hide Ratings",
    useTiers: "Use Tier Badges",
    language: "Language",
    replayTutorial: "Replay Tutorial",
    needsLoan: "Needs Loan Players",
    borrowPlayer: "Borrow from resting team:",
    guest: "Guest",
    guests: "Guests",
    tactics: "Tactics",
    aiCoach: "AI Coach",
    playerProfile: "Player Profile",
    stats: "Season Stats",
    winRate: "Win Rate",
    matches: "Matches",
    wins: "Wins",
    losses: "Losses",
    draws: "Draws",
    chemistry: "Chemistry Check",
    chemistrySub: "Select 2 players to analyze:",
    gamesTogether: "Games Together",
    chemistryScore: "Chemistry Score",
    uploadPhoto: "Upload Photo",
    removePhoto: "Remove Photo",
    chemLevels: { low: "Needs Work", med: "Solid Pair", high: "Dynamic Duo", god: "Unstoppable" },
    positions: { GK: 'GK', DEF: 'DEF', MID: 'MID', FWD: 'FWD' },
    tiers: { developing: 'Developing', solid: 'Solid', pro: 'Pro' },
    prompts: {
      unevenTitle: "Uneven Squads",
      unevenText: "You have selected",
      unevenCont: "Continue",
      unevenBack: "Go Back"
    },
    account: "Account & Data",
    cloudSync: "Cloud Sync Active",
    signedInAs: "Signed in as",
    noMatches: "No matches recorded yet.",
    resumeMatch: "Resume Match",
    activeMatch: "LIVE",
    logout: "Log Out"
  },
  he: {
    appTitle: "FairPlay",
    onboardingTitle: "בלי ויכוחים.\nרק כדורגל.",
    onboardingSub: "צור קבוצות מאוזנות תוך שניות.",
    getStarted: "המשך כאורח", 
    googleLogin: "התחבר עם גוגל",
    rosterTitle: "הסגל",
    addPlayer: "הוסף שחקן",
    matchSetup: "הגדרת משחק",
    matchSetupSub: "מי משחק היום?",
    settings: "הגדרות",
    generate: "צור קבוצות",
    calculating: "מחשב...",
    resultsTitle: "ציון הוגנות",
    balanced: "מאוזן",
    transferMode: "מצב העברות",
    transferModeOn: "מצב העברות פעיל",
    adjustLineups: "שינוי הרכבים / העברות",
    matchCentre: "מרכז המשחק",
    homeTeam: "קבוצת בית",
    awayTeam: "קבוצת חוץ",
    vs: "נגד",
    homeWin: "ניצחון בית",
    draw: "תיקו",
    awayWin: "ניצחון חוץ",
    saveMatch: "סיים ושמור משחק",
    matchNamePlaceholder: "שם המשחק (אופציונלי)",
    matchLog: "היסטוריית משחקים",
    todaysMatches: "משחקים ששוחקו היום",
    leaderboard: "טבלת מובילים",
    rank: "דירוג",
    player: "שחקן",
    ratio: "% נצחונות",
    copy: "העתק",
    whatsapp: "וואטסאפ",
    install: "התקן אפליקציה",
    hideRatings: "הסתר דירוגים",
    useTiers: "השתמש בתגים",
    language: "שפה",
    replayTutorial: "הפעל מדריך מחדש",
    needsLoan: "צריך שחקני חיזוק",
    borrowPlayer: "שאל מהקבוצה שנחה:",
    guest: "אורח",
    guests: "אורחים",
    tactics: "טקטיקה",
    aiCoach: "מאמן AI",
    playerProfile: "פרופיל שחקן",
    stats: "סטטיסטיקה עונתית",
    winRate: "אחוז ניצחונות",
    matches: "משחקים",
    wins: "נצחונות",
    losses: "הפסדים",
    draws: "תיקו",
    chemistry: "בדיקת כימיה",
    chemistrySub: "בחר 2 שחקנים לבדיקה:",
    gamesTogether: "משחקים יחד",
    chemistryScore: "ציון כימיה",
    uploadPhoto: "העלה תמונה",
    removePhoto: "מחק תמונה",
    chemLevels: { low: "לא משהו", med: "צמד סולידי", high: "שילוב חזק", god: "בלתי ניתנים לעצירה" },
    positions: { GK: 'שוער', DEF: 'הגנה', MID: 'קישור', FWD: 'התקפה' },
    tiers: { developing: 'מתחיל', solid: 'סולידי', pro: 'מקצוען' },
    prompts: {
      unevenTitle: "כוחות לא שווים",
      unevenText: "בחרת",
      unevenCont: "המשך וצור",
      unevenBack: "חזור"
    },
    account: "חשבון ונתונים",
    cloudSync: "סנכרון ענן פעיל",
    signedInAs: "מחובר כ-",
    noMatches: "טרם תועדו משחקים.",
    resumeMatch: "המשך משחק",
    activeMatch: "פעיל",
    logout: "התנתק"
  },
  es: {
    appTitle: "FairPlay",
    onboardingTitle: "SIN DISCUSIONES.\nSOLO FÚTBOL.",
    onboardingSub: "Crea equipos equilibrados en segundos.",
    getStarted: "Continuar como Invitado", 
    googleLogin: "Iniciar sesión con Google",
    rosterTitle: "La Plantilla",
    addPlayer: "Añadir Jugador",
    matchSetup: "Configurar Partido",
    matchSetupSub: "¿Quién juega hoy?",
    settings: "Ajustes",
    generate: "Generar Equipos",
    calculating: "Calculando...",
    resultsTitle: "Puntuación de Justicia",
    balanced: "Equilibrado",
    transferMode: "Modo Transferencia",
    transferModeOn: "Modo Transferencia ACTIVO",
    adjustLineups: "Ajustar Alineaciones",
    matchCentre: "Centro de Partido",
    homeTeam: "Equipo Local",
    awayTeam: "Equipo Visitante",
    vs: "VS",
    homeWin: "Gana Local",
    draw: "Empate",
    awayWin: "Gana Visitante",
    saveMatch: "Guardar Partido",
    matchNamePlaceholder: "Nombre del Partido (Opcional)",
    matchLog: "Historial",
    todaysMatches: "Partidos de Hoy",
    leaderboard: "Clasificación",
    rank: "Rango",
    player: "Jugador",
    ratio: "% Vic",
    copy: "Copiar",
    whatsapp: "WhatsApp",
    install: "Instalar App",
    hideRatings: "Ocultar Valoraciones",
    useTiers: "Usar Niveles",
    language: "Idioma",
    replayTutorial: "Ver Tutorial",
    needsLoan: "Necesita Jugadores Cedidos",
    borrowPlayer: "Pedir prestado al equipo en descanso:",
    guest: "Invitado",
    guests: "Invitados",
    tactics: "Tácticas",
    aiCoach: "Entrenador IA",
    playerProfile: "Perfil de Jugador",
    stats: "Estadísticas de Temporada",
    winRate: "Porcentaje de Victorias",
    matches: "Partidos",
    wins: "Victorias",
    losses: "Derrotas",
    draws: "Empates",
    chemistry: "Química de Equipo",
    chemistrySub: "Selecciona 2 jugadores:",
    gamesTogether: "Juegos Juntos",
    chemistryScore: "Puntuación Química",
    uploadPhoto: "Subir Foto",
    removePhoto: "Eliminar Foto",
    chemLevels: { low: "Necesita Trabajo", med: "Pareja Sólida", high: "Dúo Dinámico", god: "Imparable" },
    positions: { GK: 'POR', DEF: 'DEF', MID: 'MED', FWD: 'DEL' },
    tiers: { developing: 'Novato', solid: 'Sólido', pro: 'Pro' },
    prompts: {
      unevenTitle: "Equipos Desiguales",
      unevenText: "Has seleccionado",
      unevenCont: "Continuar",
      unevenBack: "Volver"
    },
    account: "Cuenta y Datos",
    cloudSync: "Sincronización Activa",
    signedInAs: "Conectado como",
    noMatches: "No hay partidos registrados.",
    resumeMatch: "Reanudar Partido",
    activeMatch: "EN VIVO",
    logout: "Cerrar sesión"
  },
  ar: {
    appTitle: "اللعب النظيف",
    onboardingTitle: "لا جدال.\nفقط كرة قدم.",
    onboardingSub: "أنشئ فرقًا متوازنة تمامًا في ثوانٍ.",
    getStarted: "الاستمرار كضيف", 
    googleLogin: "تسجيل الدخول باستخدام جوجل",
    rosterTitle: "التشكيلة",
    addPlayer: "إضافة لاعب",
    matchSetup: "إعداد المباراة",
    matchSetupSub: "من سيلعب اليوم؟",
    settings: "الإعدادات",
    generate: "توليد الفرق",
    calculating: "جاري الحساب...",
    resultsTitle: "نقاط العدالة",
    balanced: "متوازن",
    transferMode: "وضع الانتقالات",
    transferModeOn: "وضع الانتقالات مفعل",
    adjustLineups: "تعديل التشكيلات",
    matchCentre: "مركز المباراة",
    homeTeam: "الفريق المضيف",
    awayTeam: "الفريق الضيف",
    vs: "ضد",
    homeWin: "فوز المضيف",
    draw: "تعادل",
    awayWin: "فوز الضيف",
    saveMatch: "حفظ النتيجة",
    matchNamePlaceholder: "اسم المباراة (اختياري)",
    matchLog: "سجل المباريات",
    todaysMatches: "مباريات اليوم",
    leaderboard: "لوحة المتصدرين",
    rank: "الرتبة",
    player: "اللاعب",
    ratio: "نسبة الفوز",
    copy: "نسخ",
    whatsapp: "واتساب",
    install: "تثبيت التطبيق",
    hideRatings: "إخفاء التقييمات",
    useTiers: "استخدام الشارات",
    language: "اللغة",
    replayTutorial: "إعادة الشرح",
    needsLoan: "يحتاج لاعبين معارين",
    borrowPlayer: "استعارة لاعبين من فريق الراحة:",
    guest: "ضيف",
    guests: "ضيوف",
    tactics: "تكتيكات",
    aiCoach: "مدرب ذكي",
    playerProfile: "ملف اللاعب",
    stats: "إحصائيات الموسم",
    winRate: "نسبة الفوز",
    matches: "مباريات",
    wins: "فوز",
    losses: "خسارة",
    draws: "تعادل",
    chemistry: "فحص الكيمياء",
    chemistrySub: "اختر لاعبين للتحليل:",
    gamesTogether: "مباريات معاً",
    chemistryScore: "درجة التناغم",
    uploadPhoto: "رفع صورة",
    removePhoto: "إزالة الصورة",
    chemLevels: { low: "تحتاج عمل", med: "ثنائي صلب", high: "ثنائي ديناميكي", god: "لا يقهر" },
    positions: { GK: 'حارس', DEF: 'دفاع', MID: 'وسط', FWD: 'هجوم' },
    tiers: { developing: 'ناشئ', solid: 'صلب', pro: 'محترف' },
    prompts: {
      unevenTitle: "فرق غير متساوية",
      unevenText: "لقد اخترت",
      unevenCont: "متابعة",
      unevenBack: "رجوع"
    },
    account: "الحساب والبيانات",
    cloudSync: "المزامنة السحابية نشطة",
    signedInAs: "تم تسجيل الدخول باسم",
    noMatches: "لم يتم تسجيل أي مباريات بعد.",
    resumeMatch: "استئناف المباراة",
    activeMatch: "مباشر",
    logout: "تسجيل الخروج"
  }
};

const LANGUAGES = [
  { code: 'en', label: 'English', dir: 'ltr' },
  { code: 'he', label: 'עברית', dir: 'rtl' },
  { code: 'es', label: 'Español', dir: 'ltr' },
  { code: 'ar', label: 'العربية', dir: 'rtl' }
];

const POSITIONS_KEYS = ['GK', 'DEF', 'MID', 'FWD'];

const generateUUID = () => Math.random().toString(36).substr(2, 9);

const getDefaultMatchName = () => {
  const date = new Date();
  return `Match on ${date.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' })}`;
};

// --- COMPONENTS ---

const Toast = ({ message, isError, onClose, isRtl }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`fixed top-6 left-1/2 transform -translate-x-1/2 z-[70] px-6 py-3 rounded-full shadow-2xl flex items-center gap-3 animate-bounce-in ${isError ? 'bg-red-500 text-white' : 'bg-lime-400 text-slate-900'} ${isRtl ? 'flex-row-reverse' : ''}`}>
      {isError ? <AlertCircle size={20} /> : <Check size={20} />}
      <span className="font-bold text-sm">{message}</span>
    </div>
  );
};

const ComingSoonModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/80 backdrop-blur-sm p-6 animate-fade-in">
      <div className="bg-slate-900 w-full max-w-sm rounded-3xl border border-slate-700 p-8 shadow-2xl relative text-center">
        <button onClick={onClose} className="absolute top-4 right-4 text-slate-500 hover:text-white"><X size={24} /></button>
        <div className="flex justify-center mb-6">
           <div className="w-20 h-20 bg-indigo-900/50 rounded-full flex items-center justify-center shadow-inner border border-indigo-500/30 relative overflow-hidden">
             <div className="absolute inset-0 bg-indigo-500/20 animate-pulse rounded-full"></div>
             <Bot size={40} className="text-indigo-400 relative z-10" />
           </div>
        </div>
        <h3 className="text-2xl font-bold text-white mb-3">Coming Soon! 🚀</h3>
        <p className="text-slate-400 leading-relaxed mb-6 text-sm">
          Our <strong>AI Coach</strong> is currently at a training camp in the mountains. This feature will be available in a future update!
        </p>
        <button onClick={onClose} className="w-full py-3 rounded-xl font-bold text-white bg-indigo-600 hover:bg-indigo-500 transition-colors shadow-lg shadow-indigo-500/20">
          Okay, I'll wait!
        </button>
      </div>
    </div>
  );
};

const MatchTimer = ({ t }) => {
  const [timeLeft, setTimeLeft] = useState(600); // Default 10m
  const [initialTime, setInitialTime] = useState(600);
  const [isRunning, setIsRunning] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  
  // Edit state
  const [mins, setMins] = useState(10);
  const [secs, setSecs] = useState(0);

  const timerRef = useRef(null);

  useEffect(() => {
    if (isRunning && timeLeft > 0) {
      timerRef.current = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            setIsRunning(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } else {
      clearInterval(timerRef.current);
    }
    return () => clearInterval(timerRef.current);
  }, [isRunning, timeLeft]);

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };

  const handleSave = () => {
    const newTime = (parseInt(mins) || 0) * 60 + (parseInt(secs) || 0);
    setInitialTime(newTime);
    setTimeLeft(newTime);
    setIsEditing(false);
    setIsRunning(false);
  };

  const toggleTimer = () => {
    if (timeLeft === 0 && !isRunning) return;
    setIsRunning(!isRunning);
  };

  const reset = () => {
    setIsRunning(false);
    setTimeLeft(initialTime);
  };

  return (
    <div className="bg-slate-800 rounded-xl p-3 border border-slate-700 flex items-center justify-between mb-4 shadow-inner">
      
      {isEditing ? (
         <div className="flex items-center gap-2">
            <input 
              type="number" 
              value={mins} 
              onChange={(e) => setMins(e.target.value)}
              className="w-12 bg-slate-900 text-white border border-slate-600 rounded p-1 text-center font-mono text-lg"
              placeholder="MM"
            />
            <span className="text-slate-400 font-bold">:</span>
            <input 
              type="number" 
              value={secs} 
              onChange={(e) => setSecs(e.target.value)}
              className="w-12 bg-slate-900 text-white border border-slate-600 rounded p-1 text-center font-mono text-lg"
              placeholder="SS"
            />
            <button onClick={handleSave} className="bg-lime-500 text-black p-2 rounded hover:bg-lime-400">
               <Check size={16} />
            </button>
         </div>
      ) : (
        <div className="flex items-center gap-3">
          <div className={`font-mono text-2xl font-bold tracking-wider bg-slate-900 px-3 py-1 rounded border border-slate-700/50 ${timeLeft === 0 ? 'text-red-500 animate-pulse border-red-500/50' : 'text-lime-400'}`}>
            {formatTime(timeLeft)}
          </div>
          <button onClick={() => { setIsEditing(true); setIsRunning(false); setMins(Math.floor(timeLeft/60)); setSecs(timeLeft%60); }} className="text-slate-500 hover:text-white transition-colors p-2">
             <Edit2 size={16} />
          </button>
        </div>
      )}

      <div className="flex gap-2">
        <button 
          onClick={toggleTimer} 
          disabled={isEditing || (timeLeft === 0 && !isRunning)}
          className={`w-10 h-10 rounded-full flex items-center justify-center transition-all ${isRunning ? 'bg-amber-500 text-slate-900' : 'bg-lime-500 text-slate-900'} ${timeLeft === 0 && !isRunning ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          {isRunning ? <Pause size={20} fill="currentColor" /> : <Play size={20} fill="currentColor" className="ml-1 rtl:mr-1 rtl:ml-0"/>}
        </button>
        <button 
          onClick={reset}
          disabled={isEditing}
          className="w-10 h-10 rounded-full bg-slate-700 text-slate-400 flex items-center justify-center hover:bg-slate-600 hover:text-white transition-all"
        >
          <RotateCcw size={18} />
        </button>
      </div>
    </div>
  );
};

const Onboarding = ({ onStart, onGoogle, t, loading }) => (
  <div className="flex flex-col items-center justify-center h-screen bg-slate-950 px-6 text-center relative overflow-hidden">
    <div className="absolute top-[-10%] left-[-10%] w-96 h-96 bg-lime-500/10 rounded-full blur-3xl pointer-events-none" />
    <div className="absolute bottom-[-10%] right-[-10%] w-96 h-96 bg-emerald-500/10 rounded-full blur-3xl pointer-events-none" />

    <div className="z-10 flex flex-col items-center animate-fade-in w-full max-w-xs">
      <div className="w-20 h-20 bg-lime-500 rounded-2xl flex items-center justify-center mb-8 shadow-[0_0_30px_rgba(132,204,22,0.4)] rotate-3">
        {loading ? <Loader2 size={40} className="text-slate-900 animate-spin" /> : <Shield size={40} className="text-slate-900" strokeWidth={2.5} />}
      </div>
      <h1 className="text-4xl font-bold text-white mb-4 tracking-tight whitespace-pre-line">
        {t.onboardingTitle}
      </h1>
      <p className="text-slate-400 text-lg mb-10 leading-relaxed">
        {loading ? "Connecting to your account..." : t.onboardingSub}
      </p>
      
      <button 
        onClick={onGoogle}
        disabled={loading}
        className="w-full bg-white hover:bg-slate-100 text-slate-900 font-bold py-3.5 rounded-xl text-lg transition-all mb-3 flex items-center justify-center gap-2 shadow-lg disabled:opacity-70 disabled:cursor-wait"
      >
        {loading ? <Loader2 size={20} className="animate-spin text-blue-500"/> : (
          <svg viewBox="0 0 24 24" className="w-5 h-5" xmlns="http://www.w3.org/2000/svg"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/></svg>
        )}
        {t.googleLogin}
      </button>

      <button 
        onClick={onStart}
        disabled={loading}
        className="w-full bg-slate-800 hover:bg-slate-700 border border-slate-700 text-slate-300 font-bold py-3.5 rounded-xl text-lg transition-all"
      >
        {t.getStarted}
      </button>

      {loading && <div className="mt-4 text-xs text-slate-500 flex items-center gap-2 justify-center"><Cloud size={12}/> Syncing...</div>}
    </div>
  </div>
);

const TutorialModal = ({ isOpen, onClose }) => {
  const [step, setStep] = useState(0);
  
  const steps = [
    {
      title: "Welcome Manager!",
      text: "FairPlay helps you organize casual matches without the drama. Your data is now synced to your secure cloud account.",
      icon: <Shield size={48} className="text-lime-400" />
    },
    {
      title: "We Speak Your Language",
      text: "FairPlay is now global! Go to Settings to switch between English, Hebrew (עברית), Spanish, and Arabic.",
      icon: <Globe size={48} className="text-blue-400" />
    },
    {
      title: "Smart Balancing",
      text: "We now distribute Goalkeepers evenly first, then balance the rest of the squad based on skill rating.",
      icon: <Activity size={48} className="text-purple-400" />
    },
    {
      title: "Multiple Loan Players",
      text: "Uneven teams? (e.g., 5 vs 3). In Match Centre, you can borrow MULTIPLE players from the resting team until the squads are even!",
      icon: <ArrowRightLeft size={48} className="text-amber-400" />
    },
    {
      title: "Match History & Stats",
      text: "Record scores, name your matches, and track player stats like Win Rate automatically!",
      icon: <BarChart3 size={48} className="text-lime-400" />
    }
  ];

  if (!isOpen) return null;

  const currentStep = steps[step];

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/90 backdrop-blur-sm p-6 animate-fade-in">
      <div className="bg-slate-900 w-full max-w-sm rounded-3xl border border-slate-700 p-8 shadow-2xl relative text-center">
        <div className="flex justify-center mb-6">
           <div className="w-20 h-20 bg-slate-800 rounded-full flex items-center justify-center shadow-inner border border-slate-700">
             {currentStep.icon}
           </div>
        </div>
        <h3 className="text-2xl font-bold text-white mb-4">{currentStep.title}</h3>
        <p className="text-slate-400 leading-relaxed mb-8 min-h-[80px]">{currentStep.text}</p>
        
        <div className="flex gap-2">
          {step > 0 && (
            <button onClick={() => setStep(step - 1)} className="flex-1 py-3 rounded-xl font-bold text-slate-400 hover:text-white bg-slate-800 transition-colors">
              Back
            </button>
          )}
          <button 
            onClick={() => {
              if (step < steps.length - 1) setStep(step + 1);
              else {
                setStep(0); // Reset for next time
                onClose();
              }
            }} 
            className="flex-[2] py-3 rounded-xl font-bold text-slate-900 bg-lime-400 hover:bg-lime-500 transition-colors shadow-lg shadow-lime-400/20"
          >
            {step < steps.length - 1 ? 'Next' : "Let's Play!"}
          </button>
        </div>

        <div className="flex justify-center gap-2 mt-6">
          {steps.map((_, i) => (
            <div key={i} className={`w-2 h-2 rounded-full transition-all ${i === step ? 'bg-lime-400 w-6' : 'bg-slate-700'}`} />
          ))}
        </div>
      </div>
    </div>
  );
};

const UnevenTeamsModal = ({ isOpen, count, numTeams, onClose, onConfirm, t }) => {
  if (!isOpen) return null;

  const minPlayers = Math.floor(count / numTeams);
  const extraPlayers = count % numTeams;
  const teamsWithMore = extraPlayers;
  const teamsWithLess = numTeams - extraPlayers;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4 animate-fade-in">
      <div className="bg-slate-900 w-full max-w-sm rounded-2xl border border-slate-700 p-6 shadow-2xl">
        <div className="flex items-center gap-3 mb-4 text-amber-400">
          <Info size={28} />
          <h3 className="text-xl font-bold text-white">{t.prompts.unevenTitle}</h3>
        </div>
        <p className="text-slate-300 mb-4">
          {t.prompts.unevenText} <strong>{count}</strong> ({numTeams} Teams).
        </p>
        
        <div className="bg-slate-800/50 p-4 rounded-xl border border-slate-700 mb-6 text-sm">
          <div className="flex justify-between mb-2">
            <span className="text-slate-400">{teamsWithMore} Teams:</span>
            <span className="text-white font-bold">{minPlayers + 1} Players</span>
          </div>
          <div className="flex justify-between">
            <span className="text-slate-400">{teamsWithLess} Teams:</span>
            <span className="text-amber-400 font-bold">{minPlayers} Players</span>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          <button 
            onClick={onConfirm} 
            className="w-full bg-lime-400 hover:bg-lime-500 text-slate-900 font-bold py-3 rounded-xl transition-all"
          >
            {t.prompts.unevenCont}
          </button>
          <button 
            onClick={onClose} 
            className="text-slate-500 text-sm font-medium mt-2 hover:text-white"
          >
            {t.prompts.unevenBack}
          </button>
        </div>
      </div>
    </div>
  );
};

const ChemistryModal = ({ isOpen, onClose, players, matchHistory, t }) => {
  const [selected1, setSelected1] = useState(null);
  const [selected2, setSelected2] = useState(null);
  
  if (!isOpen) return null;

  const calculateChemistry = () => {
    if (!selected1 || !selected2) return null;
    let together = 0, wins = 0;

    matchHistory.forEach(match => {
      // Only finished matches count for chemistry
      if (match.status && match.status !== 'finished') return;

      const teamAPlayers = match.teamAPlayers || [];
      const teamBPlayers = match.teamBPlayers || [];
      
      const inTeamA = teamAPlayers.includes(selected1) && teamAPlayers.includes(selected2);
      const inTeamB = teamBPlayers.includes(selected1) && teamBPlayers.includes(selected2);

      if (inTeamA) { together++; if (match.winner === 'A') wins++; }
      if (inTeamB) { together++; if (match.winner === 'B') wins++; }
    });

    const rate = together > 0 ? Math.round((wins/together) * 100) : 0;
    return { together, rate };
  };

  const result = calculateChemistry();
  const getChemLevel = (rate) => {
     if (rate >= 80) return { label: t.chemLevels.god, color: 'text-purple-400' };
     if (rate >= 60) return { label: t.chemLevels.high, color: 'text-lime-400' };
     if (rate >= 40) return { label: t.chemLevels.med, color: 'text-yellow-400' };
     return { label: t.chemLevels.low, color: 'text-red-400' };
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/90 backdrop-blur-sm p-4 animate-fade-in">
      <div className="bg-slate-900 w-full max-w-sm rounded-3xl border border-slate-700 p-6 shadow-2xl relative h-[500px] flex flex-col">
         <div className="flex justify-between items-center mb-4">
           <h3 className="text-xl font-bold text-white flex items-center gap-2"><FlaskConical className="text-pink-500" /> {t.chemistry}</h3>
           <button onClick={onClose} className="text-slate-500 hover:text-white"><X size={24}/></button>
         </div>
         <div className="text-slate-400 text-sm mb-4">{t.chemistrySub}</div>
         <div className="grid grid-cols-2 gap-3 mb-6">
            <div className="bg-slate-800 p-2 rounded-xl border border-slate-700">
               <select className="w-full bg-transparent text-white text-sm p-1 outline-none cursor-pointer bg-slate-800" onChange={(e) => setSelected1(e.target.value)} value={selected1 || ''}>
                 <option value="" className="bg-slate-800">Player 1</option>
                 {players.map(p => <option key={p.id} value={p.id} className="bg-slate-800">{p.name}</option>)}
               </select>
            </div>
            <div className="bg-slate-800 p-2 rounded-xl border border-slate-700">
               <select className="w-full bg-transparent text-white text-sm p-1 outline-none cursor-pointer bg-slate-800" onChange={(e) => setSelected2(e.target.value)} value={selected2 || ''}>
                 <option value="" className="bg-slate-800">Player 2</option>
                 {players.filter(p => p.id !== selected1).map(p => <option key={p.id} value={p.id} className="bg-slate-800">{p.name}</option>)}
               </select>
            </div>
         </div>
         <div className="flex-1 flex flex-col items-center justify-center bg-slate-800/30 rounded-2xl p-4 border border-slate-800 relative overflow-hidden">
            {result && selected1 && selected2 ? (
               <>
                 <div className="text-center mb-6"><div className="text-4xl font-black text-white mb-1">{result.rate}%</div><div className="text-xs uppercase tracking-widest text-slate-500">{t.chemistryScore}</div></div>
                 <div className="w-full h-4 bg-slate-700 rounded-full mb-4 relative overflow-hidden"><div className={`h-full rounded-full transition-all duration-1000 ${getChemLevel(result.rate).color.replace('text', 'bg')}`} style={{width: `${result.rate}%`}}></div></div>
                 <div className={`text-xl font-bold ${getChemLevel(result.rate).color} mb-6`}>{getChemLevel(result.rate).label}</div>
                 <div className="flex gap-4 text-xs text-slate-400"><span>{t.gamesTogether}: <strong className="text-white">{result.together}</strong></span></div>
               </>
            ) : (
               <div className="text-slate-600 text-center"><FlaskConical size={48} className="mx-auto mb-2 opacity-20" /><p>Select two players.</p></div>
            )}
         </div>
      </div>
    </div>
  );
};

// NEW: Leaderboard Component
const LeaderboardView = ({ players, t }) => {
  const [sortType, setSortType] = useState('ratio'); // ratio | wins

  const processedPlayers = players
    .map(p => {
      const stats = p.stats || { wins: 0, losses: 0, draws: 0, gamesPlayed: 0 };
      const ratio = stats.gamesPlayed > 0 ? (stats.wins / stats.gamesPlayed) : 0;
      return { ...p, ...stats, ratio };
    })
    .filter(p => p.gamesPlayed > 0) // Only show active players
    .sort((a, b) => {
       if (sortType === 'ratio') {
          if (b.ratio !== a.ratio) return b.ratio - a.ratio;
          return b.gamesPlayed - a.gamesPlayed; // Tie breaker
       } else {
          return b.wins - a.wins;
       }
    });

  return (
    <div className="animate-fade-in pb-24">
       <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-white">{t.leaderboard}</h2>
          <div className="flex bg-slate-800 rounded-lg p-1">
             <button onClick={() => setSortType('ratio')} className={`px-3 py-1 rounded text-xs font-bold transition-all ${sortType === 'ratio' ? 'bg-slate-700 text-white' : 'text-slate-500'}`}>Ratio</button>
             <button onClick={() => setSortType('wins')} className={`px-3 py-1 rounded text-xs font-bold transition-all ${sortType === 'wins' ? 'bg-slate-700 text-white' : 'text-slate-500'}`}>Wins</button>
          </div>
       </div>
       
       {processedPlayers.length === 0 ? (
         <div className="text-center py-12 text-slate-500"><Trophy size={48} className="mx-auto mb-4 opacity-20"/><p>{t.noMatches}</p></div>
       ) : (
         <div className="space-y-2">
           <div className="flex text-xs text-slate-500 px-4 mb-1 font-bold uppercase tracking-wider">
             <div className="w-8 text-center">#</div>
             <div className="flex-1">{t.player}</div>
             <div className="w-16 text-center">{sortType === 'ratio' ? t.ratio : t.wins}</div>
             <div className="w-16 text-center">{t.matches}</div>
           </div>
           {processedPlayers.map((p, idx) => {
             let medalColor = '';
             if (idx === 0) medalColor = 'text-yellow-400';
             if (idx === 1) medalColor = 'text-slate-300';
             if (idx === 2) medalColor = 'text-amber-600';
             
             return (
               <div key={p.id} className="bg-slate-900 border border-slate-800 p-3 rounded-xl flex items-center">
                 <div className={`w-8 text-center font-bold ${medalColor || 'text-slate-500'}`}>
                   {idx < 3 ? <Medal size={20} className="mx-auto"/> : idx + 1}
                 </div>
                 <div className="flex-1 flex items-center gap-3 pl-2">
                    {p.image ? (
                       <img src={p.image} alt={p.name} className="w-8 h-8 rounded-full object-cover bg-slate-800 border border-slate-700" />
                    ) : (
                       <div className="w-8 h-8 rounded-full bg-slate-800 flex items-center justify-center text-xs font-bold text-slate-400">{p.name.substring(0,2).toUpperCase()}</div>
                    )}
                    <span className="text-white font-bold text-sm">{p.name}</span>
                 </div>
                 <div className="w-16 text-center font-mono font-bold text-lime-400">
                    {sortType === 'ratio' ? `${Math.round(p.ratio * 100)}%` : p.wins}
                 </div>
                 <div className="w-16 text-center text-xs text-slate-500 font-bold">
                    {p.gamesPlayed}
                 </div>
               </div>
             )
           })}
         </div>
       )}
    </div>
  );
};

const PlayerProfileModal = ({ isOpen, onClose, player, t }) => {
  if (!isOpen || !player) return null;

  const stats = player.stats || { wins: 0, losses: 0, draws: 0, gamesPlayed: 0 };
  const winRate = stats.gamesPlayed > 0 ? Math.round((stats.wins / stats.gamesPlayed) * 100) : 0;

  // Simple tier visual helper
  const getTierLabel = (r) => {
    if (r <= 3) return t.tiers.developing;
    if (r <= 7) return t.tiers.solid;
    return t.tiers.pro;
  };
  const tierLabel = getTierLabel(player.rating);
  
  const getTierColor = (r) => {
    if (r <= 3) return 'text-orange-400';
    if (r <= 7) return 'text-slate-300';
    return 'text-yellow-400';
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/90 backdrop-blur-sm p-4 animate-fade-in">
      <div className="bg-slate-900 w-full max-w-xs rounded-3xl border border-slate-700 p-6 shadow-2xl relative overflow-hidden">
        {/* Header bg */}
        <div className="absolute top-0 left-0 right-0 h-24 bg-gradient-to-b from-slate-800 to-slate-900"></div>
        
        <button onClick={onClose} className="absolute top-4 right-4 text-slate-400 hover:text-white z-10 bg-black/20 rounded-full p-1">
          <X size={20} />
        </button>

        <div className="relative z-10 flex flex-col items-center mt-4 mb-6">
          <div className="w-20 h-20 rounded-full bg-slate-800 border-4 border-slate-900 flex items-center justify-center text-3xl font-bold text-slate-200 shadow-xl mb-3 overflow-hidden">
             {player.image ? <img src={player.image} className="w-full h-full object-cover"/> : player.name.substring(0, 2).toUpperCase()}
          </div>
          <h2 className="text-2xl font-bold text-white">{player.name}</h2>
          <div className={`text-sm font-bold uppercase tracking-widest mt-1 ${getTierColor(player.rating)}`}>
            {t.positions[player.position]} • {tierLabel}
          </div>
        </div>

        {/* Stats Grid */}
        <div className="bg-slate-800/50 rounded-2xl p-4 border border-slate-700">
          <div className="flex items-center justify-between mb-4 border-b border-slate-700/50 pb-4">
             <div className="text-slate-400 text-xs font-bold uppercase tracking-wider">{t.winRate}</div>
             <div className="flex items-center gap-2">
               <span className={`text-2xl font-black ${winRate >= 50 ? 'text-lime-400' : 'text-amber-400'}`}>{winRate}%</span>
               <TrendingUp size={16} className={winRate >= 50 ? 'text-lime-400' : 'text-amber-400'} />
             </div>
          </div>
          
          <div className="grid grid-cols-3 gap-2 text-center">
             <div className="bg-slate-900/50 rounded-lg p-2">
               <div className="text-2xl font-bold text-white">{stats.wins}</div>
               <div className="text-[10px] text-slate-500 uppercase font-bold">{t.wins}</div>
             </div>
             <div className="bg-slate-900/50 rounded-lg p-2">
               <div className="text-2xl font-bold text-slate-300">{stats.draws}</div>
               <div className="text-[10px] text-slate-500 uppercase font-bold">{t.draws}</div>
             </div>
             <div className="bg-slate-900/50 rounded-lg p-2">
               <div className="text-2xl font-bold text-red-400">{stats.losses}</div>
               <div className="text-[10px] text-slate-500 uppercase font-bold">{t.losses}</div>
             </div>
          </div>
          
          <div className="mt-4 text-center">
             <span className="text-xs text-slate-500">{t.matches} Played: <strong className="text-slate-300">{stats.gamesPlayed}</strong></span>
          </div>
        </div>
      </div>
    </div>
  );
};

const PlayerModal = ({ isOpen, onClose, onSave, playerToEdit, t }) => {
  const [name, setName] = useState('');
  const [position, setPosition] = useState('MID');
  const [rating, setRating] = useState(5.0);
  const [image, setImage] = useState('');
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      if (playerToEdit) {
        setName(playerToEdit.name);
        setPosition(playerToEdit.position);
        setRating(playerToEdit.rating);
        setImage(playerToEdit.image || '');
      } else {
        setName('');
        setPosition('MID');
        setRating(5.0);
        setImage('');
      }
    }
  }, [isOpen, playerToEdit]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  if (!isOpen) return null;

  // Simple tier visual helper
  const getTierLabel = (r) => {
    if (r <= 3) return t.tiers.developing;
    if (r <= 7) return t.tiers.solid;
    return t.tiers.pro;
  };
  const tierLabel = getTierLabel(rating);

  // Color helper
  const getTierColor = (r) => {
    if (r <= 3) return 'text-orange-400';
    if (r <= 7) return 'text-slate-300';
    return 'text-yellow-400';
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/80 backdrop-blur-sm p-4 animate-fade-in">
      <div className="bg-slate-900 w-full max-w-md rounded-2xl border border-slate-800 p-6 shadow-2xl relative">
        <button onClick={onClose} className="absolute top-4 right-4 rtl:right-auto rtl:left-4 text-slate-500 hover:text-white">
          <X size={24} />
        </button>
        
        <h2 className="text-2xl font-bold text-white mb-6 flex items-center gap-2">
          {playerToEdit ? <Edit2 size={24}/> : <Plus size={24}/>} 
          {playerToEdit ? 'Edit' : 'Add'}
        </h2>

        <div className="space-y-6">
          {/* Name */}
          <div>
            <label className="block text-slate-400 text-sm font-medium mb-2">Name</label>
            <input 
              type="text" 
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. Leo"
              className="w-full bg-slate-800 border border-slate-700 text-white rounded-xl p-4 focus:border-lime-400 focus:ring-1 focus:ring-lime-400 outline-none transition-all"
              autoFocus
            />
          </div>

          {/* Image Upload Section */}
          <div>
            <label className="block text-slate-400 text-sm font-medium mb-2">Photo</label>
            <div className="flex gap-3 items-center">
               {image && <img src={image} alt="Preview" className="w-12 h-12 rounded-full object-cover bg-slate-800 border border-slate-700" />}
               <button 
                 onClick={() => fileInputRef.current.click()} 
                 className="flex-1 bg-slate-800 border border-slate-700 text-white rounded-xl p-3 flex items-center justify-center gap-2 hover:bg-slate-700 transition-colors"
               >
                 <Upload size={16} /> {t.uploadPhoto}
               </button>
               {image && (
                 <button 
                   onClick={() => setImage('')}
                   className="bg-red-500/20 border border-red-500/50 text-red-400 rounded-xl p-3 flex items-center justify-center hover:bg-red-500/30 transition-colors"
                 >
                   <Trash2 size={16} />
                 </button>
               )}
               <input 
                 type="file" 
                 ref={fileInputRef} 
                 onChange={handleFileChange} 
                 accept="image/*" 
                 className="hidden" 
               />
            </div>
          </div>

          {/* Position */}
          <div>
            <label className="block text-slate-400 text-sm font-medium mb-2">Position</label>
            <div className="flex gap-2">
              {POSITIONS_KEYS.map(posKey => (
                <button
                  key={posKey}
                  onClick={() => setPosition(posKey)}
                  className={`flex-1 py-2 rounded-lg text-sm font-bold border transition-all ${
                    position === posKey 
                      ? 'bg-lime-400 text-slate-900 border-lime-400' 
                      : 'bg-slate-800 text-slate-400 border-slate-700 hover:border-slate-500'
                  }`}
                >
                  {t.positions[posKey]}
                </button>
              ))}
            </div>
          </div>

          {/* Rating Slider */}
          <div className="bg-slate-800/50 p-4 rounded-xl border border-slate-700/50">
            <div className="flex justify-between items-end mb-4">
              <label className="text-slate-400 text-sm font-medium">Rating</label>
              <div className="text-right rtl:text-left">
                <span className={`text-sm font-bold ${getTierColor(rating)} uppercase tracking-wider`}>{tierLabel}</span>
                <span className="ml-2 rtl:ml-0 rtl:mr-2 text-2xl font-bold text-white">{rating}</span>
              </div>
            </div>
            <input 
              type="range" 
              min="1" 
              max="10" 
              step="0.5" 
              value={rating}
              onChange={(e) => setRating(parseFloat(e.target.value))}
              className="w-full h-2 bg-slate-700 rounded-lg appearance-none cursor-pointer accent-lime-400"
            />
          </div>

          <button 
            onClick={() => {
              if (!name.trim()) return;
              onSave({ id: playerToEdit?.id, name, position, rating, image });
            }}
            disabled={!name.trim()}
            className="w-full bg-lime-400 disabled:opacity-50 hover:bg-lime-500 text-slate-900 font-bold py-4 rounded-xl text-lg shadow-lg transition-all"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

// 7. Main Application Logic
export default function FairPlayTeams() {
  // --- STATE ---
  const [language, setLanguage] = useState('en');
  const [currentView, setCurrentView] = useState('onboarding'); 
  const [players, setPlayers] = useState([]);
  const [selectedPlayerIds, setSelectedPlayerIds] = useState(new Set());
  const [teams, setTeams] = useState([]);
  const [numTeams, setNumTeams] = useState(2);
  const [settings, setSettings] = useState({
    hideRatings: false,
    useTiers: true,
    hasSeenTutorial: false
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTutorialOpen, setIsTutorialOpen] = useState(false);
  const [showUnevenPrompt, setShowUnevenPrompt] = useState(false);
  const [isComingSoonOpen, setIsComingSoonOpen] = useState(false);
  const [isChemOpen, setIsChemOpen] = useState(false);
  const [editingPlayer, setEditingPlayer] = useState(null);
  const [fairnessScore, setFairnessScore] = useState(100);
  const [animating, setAnimating] = useState(false);
  const [toast, setToast] = useState(null); 
  
  // Profile Modal State
  const [profilePlayer, setProfilePlayer] = useState(null);

  // Match Tracker & AI
  const [matchHistory, setMatchHistory] = useState([]);
  const [selectedTeamA, setSelectedTeamA] = useState(''); 
  const [selectedTeamB, setSelectedTeamB] = useState(''); 
  const [loanPlayers, setLoanPlayers] = useState([]); 
  const [aiLoading, setAiLoading] = useState(false);
  const [matchCommentary, setMatchCommentary] = useState(null);
  const [teamTactics, setTeamTactics] = useState({}); 
  const [expandedGkTeam, setExpandedGkTeam] = useState(null); 
  const [isTransferMode, setIsTransferMode] = useState(false);
  const [selectedTransferPlayer, setSelectedTransferPlayer] = useState(null); 
  
  // New State for Score & Naming
  const [scoreA, setScoreA] = useState(0);
  const [scoreB, setScoreB] = useState(0);
  const [matchName, setMatchName] = useState('');
  const [currentMatchId, setCurrentMatchId] = useState(null);

  // FIREBASE USER STATE
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const TEAM_COLORS = [
    'border-blue-500/30 bg-blue-500/5 shadow-blue-500/10',
    'border-red-500/30 bg-red-500/5 shadow-red-500/10',
    'border-emerald-500/30 bg-emerald-500/5 shadow-emerald-500/10',
    'border-amber-500/30 bg-amber-500/5 shadow-amber-500/10'
  ];

  // --- FIREBASE INIT ---
  // --- REPLACED WITH USER PROVIDED CONFIG ---
  const firebaseConfig = {
    apiKey: "AIzaSyBOgdNRFx4rpWiwxaI1xNL_4yRnj41_i2I",
    authDomain: "fairplay-app-ef195.firebaseapp.com",
    projectId: "fairplay-app-ef195",
    storageBucket: "fairplay-app-ef195.firebasestorage.app",
    messagingSenderId: "499652140912",
    appId: "1:499652140912:web:05c9900ff3635a984839b5",
    measurementId: "G-LTLNV7BKF4"
  };

  const app = initializeApp(firebaseConfig);
  const auth = getAuth(app);
  const db = getFirestore(app);
  const analytics = getAnalytics(app);

  // --- DERIVED STATE ---
  const t = TRANSLATIONS[language];
  const currentLangObj = LANGUAGES.find(l => l.code === language);
  const isRtl = currentLangObj.dir === 'rtl';

  // --- EFFECTS ---

  // 1. Auth Listener
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
      // FIX: Automatically navigate to roster if user is logged in
      if (currentUser) {
        setCurrentView('roster');
      }
    });
    return () => unsubscribe();
  }, []);

  // 2. Data Listeners (Firestore)
  useEffect(() => {
    if (!user) {
        // Clear data on logout
        setPlayers([]);
        setMatchHistory([]);
        return;
    };

    // A. Players Listener - UPDATED PATH: users/{uid}/players
    const playersQuery = collection(db, 'users', user.uid, 'players');
    const unsubPlayers = onSnapshot(playersQuery, (snapshot) => {
      const loadedPlayers = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setPlayers(loadedPlayers);
    }, (err) => console.error("Players sync error", err));

    // B. Settings Listener - UPDATED PATH: users/{uid}/settings/config
    const settingsRef = doc(db, 'users', user.uid, 'settings', 'config');
    const unsubSettings = onSnapshot(settingsRef, (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setSettings(data);
        if (data.language && TRANSLATIONS[data.language]) {
          setLanguage(data.language);
        }
      }
    }, (err) => console.error("Settings sync error", err));

    // C. Matches Listener - UPDATED PATH: users/{uid}/matches
    const matchesQuery = collection(db, 'users', user.uid, 'matches');
    const unsubMatches = onSnapshot(matchesQuery, (snapshot) => {
      const loadedMatches = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      loadedMatches.sort((a, b) => {
         return new Date(b.created || 0) - new Date(a.created || 0);
      });
      setMatchHistory(loadedMatches);
    }, (err) => console.error("Matches sync error", err));

    return () => {
      unsubPlayers();
      unsubSettings();
      unsubMatches();
    };
  }, [user]);

  useEffect(() => {
    if (currentView === 'results' && teams.length >= 2 && !selectedTeamA) {
      // If we resumed a match, don't override selections
      if (!currentMatchId) {
        setSelectedTeamA(teams[0].id.toString());
        setSelectedTeamB(teams[1].id.toString());
        setScoreA(0);
        setScoreB(0);
        setMatchName(getDefaultMatchName());
      }
    }
  }, [currentView, teams, currentMatchId]);

  useEffect(() => {
    setLoanPlayers([]);
  }, [selectedTeamA, selectedTeamB]);

  // Update Fairness Score on Teams Change (Effect based recalculation)
  useEffect(() => {
    if (teams.length > 0) {
      // FIX: Calculate totals dynamically from players array
      // Using TOTAL RATING (Sum) instead of Average + Player Count penalty
      // This allows a smaller team of pros to be "balanced" against a larger team of beginners
      const teamTotals = teams.map(t => 
        t.players.reduce((sum, p) => sum + (Number(p.rating) || 0), 0)
      );
      
      const maxTotal = Math.max(...teamTotals);
      const minTotal = Math.min(...teamTotals);
      
      // Formula: (Lowest Total / Highest Total) * 100
      // Example: Team A (10) vs Team B (10) = 100%
      // Example: Team A (10) vs Team B (5) = 50%
      let score = 0;
      if (maxTotal === 0) {
          score = 100;
      } else {
          score = Math.round((minTotal / maxTotal) * 100);
      }
      
      setFairnessScore(score);

      // AUTO-UPDATE ACTIVE MATCH DRAFT
      // If we are in an active match/draft, save lineup changes to cloud immediately
      if (currentMatchId && user) {
         const matchRef = doc(db, 'users', user.uid, 'matches', currentMatchId);
         const tA = teams[0];
         const tB = teams[1];
         // Only update if we have valid teams structure
         if (tA && tB) {
             updateDoc(matchRef, {
                teamAPlayers: tA.players.map(p=>p.id),
                teamBPlayers: tB.players.map(p=>p.id),
                teamAGkOrder: tA.gkOrder.map(p=>p.id),
                teamBGkOrder: tB.gkOrder.map(p=>p.id)
             }).catch(err => console.log("Auto-save draft error (minor)", err));
         }
      }
    }
  }, [teams, currentMatchId, user]); // Added deps to ensure updates run

  // --- HANDLERS ---

  const changeLanguage = async (code) => {
    setLanguage(code);
    if (user) {
      const settingsRef = doc(db, 'users', user.uid, 'settings', 'config');
      await setDoc(settingsRef, { ...settings, language: code }, { merge: true });
    }
  };

  const showToast = (message, isError = false) => {
    setToast({ message, isError });
  };

  const handleStart = () => {
    if (loading) return;
    signInAnonymously(auth).catch(e => {
        console.error(e);
        showToast("Guest login failed", true);
    });
  };

  const handleGoogleLogin = async () => {
    setLoading(true); // Show loading
    const provider = new GoogleAuthProvider();
    try {
        const result = await signInWithPopup(auth, provider);
        if (result.user) {
             setUser(result.user);
             setCurrentView('roster');
        }
    } catch (e) {
        console.error(e);
        if (e.code === 'auth/unauthorized-domain') {
            const domain = window.location.hostname;
            alert(`Setup Required:\n\nGo to Firebase Console -> Authentication -> Settings -> Authorized Domains.\n\nAdd this domain:\n${domain}`);
        } else {
            showToast("Login failed: " + e.message, true);
        }
    } finally {
        setLoading(false);
    }
  };

  const handleLogout = () => {
      signOut(auth).then(() => {
          setCurrentView('onboarding');
      });
  };

  // ... (rest of the functions: handleSavePlayer, handleDeletePlayer, toggleSelection, toggleSelectAll, handlePlayerClickInTransferMode, handleTeamHeaderClick, addLoanPlayer, removeLoanPlayer, createActiveMatch, recordMatchResult, resumeMatch, handleGenerateClick, handleUnevenConfirmation, processTeamGeneration, handleAiFeatureClick, copyToClipboard, shareViaWhatsApp, getShortTeam, getRestingPlayers, renderRating, getGroupedHistory) ...
  
  // Re-declare handleSavePlayer etc to ensure scope
  const handleSavePlayer = async (playerData) => {
    if (!user) return;
    const stats = playerData.stats || { wins: 0, losses: 0, draws: 0, gamesPlayed: 0 };
    const completePlayer = { ...playerData, stats };
    try {
      if (editingPlayer) {
        const playerRef = doc(db, 'users', user.uid, 'players', editingPlayer.id);
        await setDoc(playerRef, completePlayer, { merge: true });
      } else {
        const newRef = doc(collection(db, 'users', user.uid, 'players'));
        await setDoc(newRef, { ...completePlayer, id: newRef.id });
        setSelectedPlayerIds(prev => new Set(prev).add(newRef.id));
      }
      setIsModalOpen(false);
      setEditingPlayer(null);
    } catch (e) {
      showToast("Error saving", true);
      console.error(e);
    }
  };

  const handleDeletePlayer = async (id) => {
    if (!user) return;
    try {
       await deleteDoc(doc(db, 'users', user.uid, 'players', id));
       const newSelected = new Set(selectedPlayerIds);
       newSelected.delete(id);
       setSelectedPlayerIds(newSelected);
       showToast("Deleted");
    } catch (e) {
       showToast("Error deleting", true);
    }
  };

  const toggleSelection = (id) => {
    const newSet = new Set(selectedPlayerIds);
    if (newSet.has(id)) newSet.delete(id);
    else newSet.add(id);
    setSelectedPlayerIds(newSet);
  };

  const toggleSelectAll = () => {
    if (selectedPlayerIds.size === players.length) {
      setSelectedPlayerIds(new Set());
    } else {
      setSelectedPlayerIds(new Set(players.map(p => p.id)));
    }
  };

  const handlePlayerClickInTransferMode = (player, fromTeamId) => {
    if (selectedTransferPlayer?.player.id === player.id) {
      setSelectedTransferPlayer(null);
    } else {
      setSelectedTransferPlayer({ player, fromTeamId });
      showToast(t.transferModeOn);
    }
  };

  const handleTeamHeaderClick = (targetTeamId) => {
    if (!isTransferMode || !selectedTransferPlayer) return;
    const { player, fromTeamId } = selectedTransferPlayer;
    if (fromTeamId === targetTeamId) return;

    const newTeams = teams.map(team => {
      if (team.id === fromTeamId) {
        return {
          ...team,
          players: team.players.filter(p => p.id !== player.id),
          gkOrder: team.gkOrder.filter(p => p.id !== player.id),
          totalRating: team.totalRating - player.rating
        };
      }
      if (team.id === targetTeamId) {
        return {
          ...team,
          players: [...team.players, player],
          gkOrder: [...team.gkOrder, player],
          totalRating: team.totalRating + player.rating
        };
      }
      return team;
    });

    setTeams(newTeams);
    setSelectedTransferPlayer(null);
  };

  const addLoanPlayer = (player) => {
    setLoanPlayers([...loanPlayers, player]);
  };

  const removeLoanPlayer = (playerId) => {
    setLoanPlayers(loanPlayers.filter(p => p.id !== playerId));
  };

  const createActiveMatch = async (generatedTeams) => {
    if (!user) return;
    const tA = generatedTeams[0];
    const tB = generatedTeams[1];
    if (!tA || !tB) return;

    const matchData = {
      name: getDefaultMatchName(),
      teamA: tA.name,
      teamB: tB.name,
      date: new Date().toLocaleDateString(),
      created: Date.now(),
      status: 'active',
      teamAPlayers: tA.players.map(p=>p.id),
      teamBPlayers: tB.players.map(p=>p.id),
      teamAGkOrder: tA.gkOrder.map(p=>p.id),
      teamBGkOrder: tB.gkOrder.map(p=>p.id),
      scoreA: 0,
      scoreB: 0,
      winner: null,
      timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
      headline: null
    };

    try {
      const matchRef = await addDoc(collection(db, 'users', user.uid, 'matches'), matchData);
      setCurrentMatchId(matchRef.id);
      setMatchName(matchData.name);
    } catch (e) {
      console.error("Error creating active match", e);
    }
  };

  const recordMatchResult = async () => {
    if (!user) return;
    if (!selectedTeamA || !selectedTeamB || selectedTeamA === selectedTeamB) return;
    
    const teamA = teams.find(t => t.id.toString() === selectedTeamA);
    const teamB = teams.find(t => t.id.toString() === selectedTeamB);

    let winner = 'Tie';
    if (scoreA > scoreB) winner = 'A';
    if (scoreB > scoreA) winner = 'B';

    const batch = writeBatch(db);
    
    const matchRef = currentMatchId 
      ? doc(db, 'users', user.uid, 'matches', currentMatchId)
      : doc(collection(db, 'users', user.uid, 'matches'));

    const matchData = {
      id: matchRef.id,
      name: matchName || getDefaultMatchName(),
      teamA: teamA.name,
      teamB: teamB.name,
      status: 'finished',
      teamAPlayers: teamA.players.map(p=>p.id),
      teamBPlayers: teamB.players.map(p=>p.id),
      teamAGkOrder: teamA.gkOrder.map(p=>p.id),
      teamBGkOrder: teamB.gkOrder.map(p=>p.id),
      scoreA: scoreA,
      scoreB: scoreB,
      winner: winner, 
      timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
      loanPlayers: loanPlayers.length > 0 ? loanPlayers.map(p => p.name).join(', ') : null
    };
    
    batch.set(matchRef, matchData, { merge: true });

    const teamAIds = new Set(teamA.players.map(p => p.id));
    const teamBIds = new Set(teamB.players.map(p => p.id));

    players.forEach(player => {
        if (teamAIds.has(player.id) || teamBIds.has(player.id)) {
            const playerRef = doc(db, 'users', user.uid, 'players', player.id);
            let newStats = { ...(player.stats || { wins: 0, losses: 0, draws: 0, gamesPlayed: 0 }) };
            newStats.gamesPlayed += 1;
            if (teamAIds.has(player.id)) {
                if (winner === 'A') newStats.wins += 1;
                else if (winner === 'B') newStats.losses += 1;
                else newStats.draws += 1;
            } else {
                if (winner === 'B') newStats.wins += 1;
                else if (winner === 'A') newStats.losses += 1;
                else newStats.draws += 1;
            }
            batch.update(playerRef, { stats: newStats });
        }
    });

    try {
        await batch.commit();
        showToast(t.matchLog);
        setCurrentMatchId(null);
        setScoreA(0);
        setScoreB(0);
        setMatchName(getDefaultMatchName());
    } catch (e) {
        console.error(e);
        showToast("Error saving match", true);
    }
  };

  const resumeMatch = (match) => {
    const teamAPlayerIds = match.teamAPlayers || [];
    const teamBPlayerIds = match.teamBPlayers || [];
    
    const teamAPlayers = players.filter(p => teamAPlayerIds.includes(p.id));
    const teamBPlayers = players.filter(p => teamBPlayerIds.includes(p.id));

    const restoreGkOrder = (teamPlayers, savedOrderIds) => {
       if (!savedOrderIds || savedOrderIds.length === 0) return [...teamPlayers];
       const ordered = [];
       savedOrderIds.forEach(id => {
         const found = teamPlayers.find(p => p.id === id);
         if (found) ordered.push(found);
       });
       teamPlayers.forEach(p => {
         if (!ordered.find(op => op.id === p.id)) ordered.push(p);
       });
       return ordered;
    };

    const teamA = {
      id: 0,
      name: match.teamA,
      players: teamAPlayers,
      gkOrder: restoreGkOrder(teamAPlayers, match.teamAGkOrder),
      totalRating: teamAPlayers.reduce((sum, p) => sum + p.rating, 0)
    };

    const teamB = {
      id: 1,
      name: match.teamB,
      players: teamBPlayers,
      gkOrder: restoreGkOrder(teamBPlayers, match.teamBGkOrder),
      totalRating: teamBPlayers.reduce((sum, p) => sum + p.rating, 0)
    };

    setTeams([teamA, teamB]);
    setSelectedTeamA('0');
    setSelectedTeamB('1');
    setScoreA(match.scoreA || 0);
    setScoreB(match.scoreB || 0);
    setMatchName(match.name);
    setCurrentMatchId(match.id);
    
    setCurrentView('results');
  };

  const handleGenerateClick = () => {
    if (selectedPlayerIds.size < numTeams) {
       showToast("Not enough players", true);
       return;
    }
    if (selectedPlayerIds.size % numTeams !== 0) {
      setShowUnevenPrompt(true);
    } else {
      processTeamGeneration();
    }
  };

  const handleUnevenConfirmation = () => {
    setShowUnevenPrompt(false);
    processTeamGeneration();
  };

  const processTeamGeneration = () => {
    setAnimating(true);
    setMatchCommentary(null); 
    setTeamTactics({}); 
    setLoanPlayers([]); 
    setIsTransferMode(false);
    setCurrentMatchId(null);
    
    const pool = players.filter(p => selectedPlayerIds.has(p.id));
    
    setTimeout(() => {
      const gks = pool.filter(p => p.position === 'GK').sort((a, b) => b.rating - a.rating);
      const fieldPlayers = pool.filter(p => p.position !== 'GK').sort((a, b) => b.rating - a.rating);

      const newTeams = Array.from({ length: numTeams }, (_, i) => ({
        id: i,
        name: `Team ${String.fromCharCode(65 + i)}`,
        players: [],
        gkOrder: [],
        totalRating: 0
      }));

      const distributeList = (listToDistribute) => {
        let chunkIndex = 0;
        while (chunkIndex < listToDistribute.length) {
          let chunk = listToDistribute.slice(chunkIndex, chunkIndex + numTeams);
          for (let i = chunk.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [chunk[i], chunk[j]] = [chunk[j], chunk[i]];
          }
          chunk.forEach(player => {
             newTeams.sort((a, b) => {
               if (a.players.length !== b.players.length) return a.players.length - b.players.length;
               return a.totalRating - b.totalRating;
             });
             newTeams[0].players.push(player);
             newTeams[0].totalRating += player.rating;
          });
          chunkIndex += numTeams;
        }
      };

      distributeList(gks);
      distributeList(fieldPlayers);
      newTeams.sort((a, b) => a.id - b.id);

      newTeams.forEach(team => {
        const shuffled = [...team.players];
        for (let i = shuffled.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        team.gkOrder = shuffled;
      });

      setTeams(newTeams);
      createActiveMatch(newTeams); 
      setAnimating(false);
      setCurrentView('results');
    }, 800); 
  };
  
  const handleAiFeatureClick = () => {
    setIsComingSoonOpen(true);
  };

  const copyToClipboard = () => {
    let text = `${t.matchLog}\n\n`;
    teams.forEach(team => {
      text += `*${team.name}*\n${team.players.map(p => p.name).join('\n')}\n\n`;
    });
    const el = document.createElement('textarea');
    el.value = text;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    showToast(t.copy);
  };

  const shareViaWhatsApp = () => {
    let text = `${t.matchLog}\n\n`;
    teams.forEach(team => {
      text += `*${team.name}*\n${team.players.map(p => p.name).join('\n')}\n\n`;
    });
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank');
  };

  const getShortTeam = (idA, idB) => {
    const teamA = teams.find(t => t.id.toString() === idA);
    const teamB = teams.find(t => t.id.toString() === idB);
    if (!teamA || !teamB) return null;
    if (teamA.players.length < teamB.players.length) return teamA;
    if (teamB.players.length < teamA.players.length) return teamB;
    return null;
  };
  
  const getRestingPlayers = (idA, idB) => {
    const activeIds = [idA, idB];
    const restingTeams = teams.filter(t => !activeIds.includes(t.id.toString()));
    let restingPlayers = [];
    restingTeams.forEach(t => restingPlayers = [...restingPlayers, ...t.players]);
    return restingPlayers;
  };

  const renderRating = (rating) => {
    if (settings.hideRatings) return <div className="w-2 h-2 rounded-full bg-lime-500/50"></div>;
    if (settings.useTiers) {
      const label = rating <= 3 ? t.tiers.developing : (rating <= 7 ? t.tiers.solid : t.tiers.pro);
      const color = rating <= 3 ? 'text-orange-400 border-orange-400 bg-orange-400/20' : (rating <= 7 ? 'text-slate-300 border-slate-400 bg-slate-400/20' : 'text-yellow-400 border-yellow-400 bg-yellow-400/20');
      return <span className={`text-xs font-bold px-2 py-1 rounded border ${color}`}>{label}</span>;
    }
    return (
      <div className="flex items-center gap-1">
        <Activity size={12} className="text-slate-500" />
        <span className="font-mono font-bold text-lime-400">{rating.toFixed(1)}</span>
      </div>
    );
  };

  const maxPlayersInTeam = Math.max(...teams.map(t => t.players.length), 0);
  const ChevronIcon = isRtl ? ChevronLeft : ChevronRight;
  const BackIcon = isRtl ? ChevronRight : ChevronLeft;

  const getGroupedHistory = () => {
    const groups = {};
    matchHistory.forEach(match => {
      const key = match.name || 'Untitled Session';
      if (!groups[key]) groups[key] = [];
      groups[key].push(match);
    });
    return Object.entries(groups);
  };

  const GroupedHistoryList = () => {
    const groups = getGroupedHistory();
    const [expandedGroup, setExpandedGroup] = useState(null);

    if (groups.length === 0) {
      return (
        <div className="text-center py-12 text-slate-500">
          <History size={48} className="mx-auto mb-4 opacity-20" />
          <p>{t.noMatches}</p>
        </div>
      );
    }

    return (
      <div className="space-y-4">
        {groups.map(([name, matches]) => (
          <div key={name} className="bg-slate-900 border border-slate-800 rounded-xl overflow-hidden">
            <div 
              onClick={() => setExpandedGroup(expandedGroup === name ? null : name)}
              className="p-4 flex justify-between items-center cursor-pointer hover:bg-slate-800/50 transition-colors"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-blue-400">
                   <Calendar size={20} />
                </div>
                <div>
                   <div className="font-bold text-white">{name}</div>
                   <div className="text-xs text-slate-500">{matches.length} {t.matches}</div>
                </div>
              </div>
              {expandedGroup === name ? <ChevronUp size={20} className="text-slate-500"/> : <ChevronDown size={20} className="text-slate-500"/>}
            </div>
            
            {expandedGroup === name && (
              <div className="border-t border-slate-800 bg-slate-800/20">
                 {matches.map((m) => (
                   <div key={m.id} className={`p-3 border-b border-slate-800/50 last:border-0 flex flex-col gap-2 ${m.status === 'active' ? 'bg-green-900/10' : ''}`}>
                      <div className="flex justify-between text-sm items-center">
                         <div className="flex gap-2 items-center">
                            {m.status === 'active' && <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"/>}
                            <span className={`font-bold ${m.winner === 'A' ? 'text-lime-400' : 'text-slate-300'}`}>{m.teamA}</span>
                         </div>
                         <span className="font-mono bg-slate-900 px-2 rounded text-white text-xs py-0.5">{m.scoreA} - {m.scoreB}</span>
                         <span className={`font-bold ${m.winner === 'B' ? 'text-lime-400' : 'text-slate-300'}`}>{m.teamB}</span>
                      </div>
                      <div className="flex justify-between items-center">
                         <span className="text-[10px] text-slate-500 font-mono">{m.timestamp}</span>
                         <div className="flex items-center gap-2">
                           {m.loanPlayers && (
                              <span className="text-[10px] text-amber-500/70 flex items-center gap-1"><ArrowRightLeft size={10} /> {t.guests}: {m.loanPlayers}</span>
                           )}
                           <button onClick={(e) => { e.stopPropagation(); resumeMatch(m); }} className="bg-lime-500/20 hover:bg-lime-500/30 text-lime-400 text-[10px] px-2 py-1 rounded font-bold flex items-center gap-1">
                              <PlayCircle size={12}/> {t.resumeMatch}
                           </button>
                         </div>
                      </div>
                   </div>
                 ))}
              </div>
            )}
          </div>
        ))}
      </div>
    );
  };

  const todaysMatches = matchHistory.filter(m => m.date === new Date().toLocaleDateString());

  return (
    <div dir={currentLangObj.dir} className="min-h-screen bg-slate-950 text-white font-sans selection:bg-lime-400 selection:text-slate-900">
      
      {toast && <Toast message={toast.message} isError={toast.isError} onClose={() => setToast(null)} isRtl={isRtl} />}

      {/* HEADER */}
      <header className="sticky top-0 z-30 bg-slate-950/80 backdrop-blur-md border-b border-slate-800 px-4 py-4 flex justify-between items-center">
        <div className="flex items-center gap-2 cursor-pointer" onClick={() => setCurrentView('roster')}>
           <div className="w-8 h-8 bg-lime-500 rounded flex items-center justify-center">
             <Shield size={18} className="text-slate-900" />
           </div>
           <span className="font-bold text-lg tracking-tight">{t.appTitle}</span>
        </div>
        {currentView === 'roster' && (
           <div className="flex items-center gap-2">
              <button onClick={() => setIsChemOpen(true)} className="p-2 text-pink-400 hover:text-pink-300 transition-colors"><FlaskConical size={24}/></button>
              <button onClick={() => setCurrentView('leaderboard')} className="p-2 text-yellow-400 hover:text-yellow-300 transition-colors"><Trophy size={24}/></button>
              <button onClick={() => setCurrentView('history')} className="p-2 text-slate-400 hover:text-white transition-colors"><History size={24}/></button>
              <button onClick={() => setCurrentView('settings')} className="p-2 text-slate-400 hover:text-white transition-colors"><Settings size={24}/></button>
           </div>
        )}
        {currentView !== 'roster' && currentView !== 'results' && (
           <button onClick={() => setCurrentView('roster')} className="p-2 text-slate-400 hover:text-white transition-colors"><X size={24}/></button>
        )}
      </header>

      {/* MAIN */}
      <main className="pb-24 px-4 pt-4 max-w-2xl mx-auto">
        
        {currentView === 'onboarding' && <Onboarding onStart={handleStart} onGoogle={handleGoogleLogin} t={t} loading={loading} />}
        
        {currentView === 'leaderboard' && <LeaderboardView players={players} t={t} />}
        
        {currentView === 'history' && (
          <div className="animate-fade-in">
             <h2 className="text-2xl font-bold text-white mb-6">{t.matchLog}</h2>
             <GroupedHistoryList />
          </div>
        )}

        {/* ROSTER */}
        {currentView === 'roster' && (
          <div className="animate-fade-in">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold text-white">{t.rosterTitle} <span className="text-slate-500 text-lg font-normal">({players.length})</span></h2>
              <button onClick={() => setCurrentView('setup')} className="flex items-center gap-2 text-lime-400 font-bold hover:text-lime-300 transition-colors">
                {t.matchSetup} <ChevronIcon size={20}/>
              </button>
            </div>

            {players.length === 0 ? (
              <div className="text-center py-12 bg-slate-900 rounded-2xl border-2 border-dashed border-slate-800">
                <Users size={48} className="mx-auto text-slate-600 mb-4" />
                <p className="text-slate-400">0 Players</p>
              </div>
            ) : (
              <div className="space-y-3">
                {players.map(player => (
                  <div 
                    key={player.id} 
                    onClick={() => setProfilePlayer(player)} // Open profile
                    className="bg-slate-900 border border-slate-800 p-4 rounded-xl flex items-center justify-between shadow-sm hover:border-slate-700 transition-all group cursor-pointer active:scale-95"
                  >
                    <div className="flex items-center gap-4">
                      {player.image ? (
                        <img src={player.image} className="w-10 h-10 rounded-full object-cover bg-slate-800 border border-slate-700" alt={player.name} />
                      ) : (
                        <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-sm font-bold text-slate-300 border border-slate-700">{player.name.substring(0, 2).toUpperCase()}</div>
                      )}
                      <div>
                        <div className="font-bold text-white">{player.name}</div>
                        <div className="text-xs text-slate-500 font-bold tracking-wider">{t.positions[player.position]}</div>
                      </div>
                    </div>
                    <div className="flex items-center gap-4">
                      {renderRating(player.rating)}
                      <div className="flex gap-1" onClick={(e) => e.stopPropagation()}> {/* Prevent edit click from opening profile */}
                        <button onClick={() => { setEditingPlayer(player); setIsModalOpen(true); }} className="p-2 text-slate-600 hover:text-white hover:bg-slate-800 rounded-lg transition-colors"><Edit2 size={16} /></button>
                        <button onClick={() => handleDeletePlayer(player.id)} className="p-2 text-slate-600 hover:text-red-400 hover:bg-red-400/10 rounded-lg transition-colors"><Trash2 size={16} /></button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* SETUP */}
        {currentView === 'setup' && (
          <div className="animate-fade-in">
             <div className="flex justify-between items-end mb-6">
              <div className="flex items-center gap-2">
                 <button onClick={() => setCurrentView('roster')} className="p-1 -ml-2 rtl:-mr-2 rtl:ml-0 text-slate-400 hover:text-white">
                   <BackIcon size={24}/>
                 </button>
                 <div>
                    <h2 className="text-2xl font-bold text-white">{t.matchSetup}</h2>
                    <p className="text-slate-400 text-sm">{t.matchSetupSub}</p>
                 </div>
              </div>
              <button onClick={toggleSelectAll} className="text-sm font-medium text-lime-400 hover:underline">
                {selectedPlayerIds.size === players.length ? 'None' : 'All'}
              </button>
            </div>

            <div className="space-y-2 mb-8"> 
              {players.map((player, idx) => (
                <div 
                  key={player.id}
                  onClick={() => toggleSelection(player.id)}
                  className={`p-4 rounded-xl flex items-center justify-between border cursor-pointer transition-all ${selectedPlayerIds.has(player.id) ? 'bg-lime-400/10 border-lime-400/50' : 'bg-slate-900 border-slate-800 hover:border-slate-700'}`}
                >
                  <div className="flex items-center gap-3">
                     <div className={`w-5 h-5 rounded-full border flex items-center justify-center transition-colors ${selectedPlayerIds.has(player.id) ? 'bg-lime-400 border-lime-400' : 'border-slate-600'}`}>
                        {selectedPlayerIds.has(player.id) && <Check size={12} className="text-black" strokeWidth={4} />}
                     </div>
                     <span className={selectedPlayerIds.has(player.id) ? 'text-white font-medium' : 'text-slate-400'}>{player.name}</span>
                  </div>
                  <span className="text-xs font-mono text-slate-600">{t.positions[player.position]}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* RESULTS */}
        {currentView === 'results' && (
          <div className="animate-fade-in pb-8">
            <div className="bg-slate-900/50 rounded-xl p-4 mb-6 border border-slate-800 text-center relative overflow-hidden">
              <div className="relative z-10">
                <div className="text-xs uppercase tracking-widest text-slate-500 mb-1">{t.resultsTitle}</div>
                <div className="text-3xl font-black text-white flex items-center justify-center gap-2">
                  <span className={fairnessScore > 80 ? 'text-lime-400' : 'text-yellow-400'}>{fairnessScore}%</span>
                  <span className="text-sm font-normal text-slate-400">{t.balanced}</span>
                </div>
                <div className="w-full bg-slate-800 h-1.5 rounded-full mt-3 overflow-hidden">
                  <div className="bg-gradient-to-r from-lime-500 to-emerald-400 h-full transition-all duration-1000" style={{ width: `${fairnessScore}%` }}></div>
                </div>
                <button onClick={() => setIsTransferMode(!isTransferMode)} className={`mt-4 w-full py-2 rounded-lg text-xs font-bold flex items-center justify-center gap-2 border transition-all ${isTransferMode ? 'bg-amber-500 text-black border-amber-500' : 'bg-slate-800 text-slate-400 border-slate-700 hover:text-white'}`}>
                  <ArrowRightLeft size={14} /> {isTransferMode ? t.transferModeOn : t.adjustLineups}
                </button>
              </div>
            </div>

            <div className="grid gap-4 mb-8">
              {teams.map((team, idx) => {
                const isShort = team.players.length < maxPlayersInTeam;
                const teamColorClass = TEAM_COLORS[idx % TEAM_COLORS.length];
                return (
                  <div key={team.id} className={`rounded-2xl overflow-hidden border shadow-lg transition-all ${isShort ? 'border-amber-500/50' : teamColorClass}`}>
                    <div onClick={() => handleTeamHeaderClick(team.id)} className={`p-4 border-b border-slate-700/50 flex justify-between items-center ${isTransferMode ? 'cursor-pointer hover:bg-slate-800' : ''}`}>
                      <div>
                        <h3 className={`font-bold text-xl text-white break-words flex items-center gap-2 ${isTransferMode && selectedTransferPlayer ? 'text-lime-400 underline decoration-dashed' : ''}`}>
                          {team.name}
                          {isTransferMode && selectedTransferPlayer && selectedTransferPlayer.fromTeamId !== team.id && (
                             <span className="text-[10px] bg-lime-500 text-black px-2 py-0.5 rounded">MOVE</span>
                          )}
                        </h3>
                        {isShort && !isTransferMode && (
                          <span className="text-[10px] font-bold bg-amber-400 text-black px-1.5 py-0.5 rounded flex items-center gap-1 w-fit mt-1">
                            <ArrowRightLeft size={10} /> {t.needsLoan}
                          </span>
                        )}
                      </div>
                      {!isTransferMode && (
                        <div className="flex gap-2">
                          <button onClick={handleAiFeatureClick} disabled={aiLoading} className={`text-xs font-bold px-2 py-1 rounded border transition-all flex items-center gap-1 ${teamTactics[team.id] ? 'bg-lime-500 text-slate-900 border-lime-500' : 'bg-slate-700 text-lime-400 border-slate-600 hover:border-lime-400'}`}>
                              <ClipboardList size={12} /> {teamTactics[team.id] ? t.tactics : t.aiCoach}
                          </button>
                          <button onClick={() => setExpandedGkTeam(expandedGkTeam === team.id ? null : team.id)} className={`text-xs font-bold px-2 py-1 rounded border transition-all ${expandedGkTeam === team.id ? 'bg-indigo-500 text-white border-indigo-500' : 'bg-slate-700 text-slate-300 border-slate-600 hover:border-slate-400'}`}>
                            {expandedGkTeam === team.id ? 'Hide' : 'GK'}
                          </button>
                        </div>
                      )}
                    </div>
                    
                    {expandedGkTeam === team.id && !isTransferMode && (
                      <div className="bg-indigo-900/20 p-3 border-b border-slate-700 animate-fade-in">
                        <div className="flex flex-wrap gap-2">
                          {team.gkOrder.map((p, i) => (
                            <div key={p.id} className="bg-slate-800 text-xs px-2 py-1 rounded border border-slate-700 text-slate-300">
                              <span className="text-indigo-400 font-bold mx-1">{i+1}.</span>{p.name}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {teamTactics[team.id] && !isTransferMode && (
                      <div className="bg-lime-900/20 p-4 border-b border-lime-500/20 animate-fade-in">
                        <div className="text-sm text-lime-100 leading-relaxed">{teamTactics[team.id]}</div>
                      </div>
                    )}

                    <div className="p-2">
                      {team.players.map(p => {
                        const isSelected = selectedTransferPlayer?.player.id === p.id;
                        return (
                          <div key={p.id} onClick={() => isTransferMode && handlePlayerClickInTransferMode(p, team.id)} className={`flex items-center justify-between p-3 border-b border-slate-700/10 last:border-0 transition-all ${isTransferMode ? 'cursor-pointer hover:bg-slate-700' : ''} ${isSelected ? 'bg-amber-500/20 border-amber-500' : ''}`}>
                            <div className="flex items-center gap-3">
                              {p.image ? <img src={p.image} className="w-8 h-8 rounded-full object-cover" /> : <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold text-slate-400 transition-colors ${isSelected ? 'bg-amber-500 text-slate-900' : 'bg-slate-700'}`}>{isTransferMode && isSelected ? <Move size={14}/> : p.name.substring(0,1)}</div>}
                              <span className={`font-medium ${isSelected ? 'text-amber-400' : 'text-slate-200'}`}>{p.name}</span>
                            </div>
                            <span className="text-xs text-slate-400 font-mono">{t.positions[p.position]}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>

            {/* MATCH CENTRE */}
            <div className="bg-slate-900 border border-slate-800 rounded-2xl p-5 mb-24">
               <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2">
                 <Swords size={20} className="text-lime-400"/> {t.matchCentre}
               </h3>
               <MatchTimer t={t} />
               
               {/* Match Name Input */}
               <div className="mb-4">
                 <input 
                   type="text" 
                   value={matchName}
                   onChange={(e) => setMatchName(e.target.value)}
                   className="w-full bg-slate-800 border border-slate-700 rounded-xl p-3 text-white text-center font-bold focus:border-lime-400 focus:outline-none"
                   placeholder={t.matchNamePlaceholder}
                 />
               </div>

               <div className="flex items-stretch gap-2 mb-4">
                 <div className="flex-1 bg-slate-800 rounded-lg p-2 border border-slate-700">
                   <label className="block text-[10px] uppercase text-slate-500 font-bold mb-1">{t.homeTeam}</label>
                   <select value={selectedTeamA} onChange={(e) => setSelectedTeamA(e.target.value)} className="w-full bg-transparent text-white text-sm font-bold outline-none">
                     <option value="" className="text-slate-500">Select</option>
                     {teams.map(t => <option key={t.id} value={t.id} className="bg-slate-900">{t.name}</option>)}
                   </select>
                 </div>
                 <div className="flex items-center justify-center bg-slate-800 rounded-lg px-3 border border-slate-700">
                   <span className="text-lime-400 font-black text-xs">{t.vs}</span>
                 </div>
                 <div className="flex-1 bg-slate-800 rounded-lg p-2 border border-slate-700">
                   <label className="block text-[10px] uppercase text-slate-500 font-bold mb-1">{t.awayTeam}</label>
                   <select value={selectedTeamB} onChange={(e) => setSelectedTeamB(e.target.value)} className="w-full bg-transparent text-white text-sm font-bold outline-none">
                     <option value="" className="text-slate-500">Select</option>
                     {teams.map(t => <option key={t.id} value={t.id} className="bg-slate-900">{t.name}</option>)}
                   </select>
                 </div>
               </div>

               {/* Scoreboard Controls */}
               {(selectedTeamA && selectedTeamB) && (
                 <div className="flex justify-between items-center mb-6 bg-slate-800/50 p-3 rounded-xl">
                   <div className="flex items-center gap-2">
                     <button onClick={() => setScoreA(Math.max(0, scoreA - 1))} className="w-8 h-8 bg-slate-700 rounded flex items-center justify-center text-slate-300 hover:bg-slate-600">-</button>
                     <span className="text-2xl font-black text-white w-8 text-center">{scoreA}</span>
                     <button onClick={() => setScoreA(scoreA + 1)} className="w-8 h-8 bg-lime-500/20 text-lime-400 rounded flex items-center justify-center hover:bg-lime-500/30">+</button>
                   </div>
                   <span className="text-slate-500 font-bold text-xs uppercase">Score</span>
                   <div className="flex items-center gap-2">
                     <button onClick={() => setScoreB(Math.max(0, scoreB - 1))} className="w-8 h-8 bg-slate-700 rounded flex items-center justify-center text-slate-300 hover:bg-slate-600">-</button>
                     <span className="text-2xl font-black text-white w-8 text-center">{scoreB}</span>
                     <button onClick={() => setScoreB(scoreB + 1)} className="w-8 h-8 bg-lime-500/20 text-lime-400 rounded flex items-center justify-center hover:bg-lime-500/30">+</button>
                   </div>
                 </div>
               )}

               {/* LOAN PLAYER */}
               {(selectedTeamA && selectedTeamB && selectedTeamA !== selectedTeamB) && (() => {
                  const shortTeam = getShortTeam(selectedTeamA, selectedTeamB);
                  const restingPlayers = getRestingPlayers(selectedTeamA, selectedTeamB);
                  
                  // Filter out already loaned players
                  const availablePlayers = restingPlayers.filter(rp => !loanPlayers.some(lp => lp.id === rp.id));

                  if (shortTeam) {
                    return (
                       <div className="mb-4 bg-amber-500/10 border border-amber-500/30 p-3 rounded-xl animate-fade-in">
                         {/* SECTION A: Borrow Players */}
                         <div className="mb-3">
                           <div className="flex items-center gap-2 mb-2">
                             <ArrowRightLeft className="text-amber-400" size={16} />
                             <div className="text-amber-400 font-bold text-sm">{shortTeam.name} {t.needsLoan}</div>
                           </div>
                           
                           {availablePlayers.length > 0 ? (
                             <div>
                               <p className="text-slate-400 text-xs mb-2">{t.borrowPlayer}</p>
                               <div className="flex flex-wrap gap-2">
                                 {availablePlayers.map(p => (
                                   <button key={p.id} onClick={() => addLoanPlayer(p)} className="bg-slate-800 hover:bg-amber-400 hover:text-black text-slate-300 text-xs px-2 py-1 rounded border border-slate-700 transition-colors flex items-center gap-1">
                                     <Plus size={10}/> {p.name}
                                   </button>
                                 ))}
                               </div>
                             </div>
                           ) : (
                             <p className="text-slate-500 text-xs italic">No resting players available.</p>
                           )}
                         </div>

                         {/* SECTION B: Active Loan Players List */}
                         {loanPlayers.length > 0 && (
                           <div className="pt-3 border-t border-amber-500/20">
                             <p className="text-amber-200 text-xs font-bold mb-2">{t.guests}:</p>
                             <div className="flex flex-wrap gap-2">
                               {loanPlayers.map(p => (
                                 <div key={p.id} className="bg-amber-400 text-black text-xs px-2 py-1 rounded font-bold flex items-center gap-2">
                                   {p.name}
                                   <button onClick={() => removeLoanPlayer(p.id)} className="hover:bg-black/20 rounded p-0.5"><X size={12}/></button>
                                 </div>
                               ))}
                             </div>
                           </div>
                         )}
                       </div>
                    );
                  }
                  return null;
               })()}

               <button onClick={handleAiFeatureClick} disabled={aiLoading || !selectedTeamA || !selectedTeamB || selectedTeamA === selectedTeamB} className="w-full mb-4 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-500 hover:to-purple-500 text-white text-sm font-bold py-3 rounded-xl flex items-center justify-center gap-2 disabled:opacity-50">
                 {aiLoading ? <RefreshCcw size={16} className="animate-spin" /> : <Mic2 size={16} />} {aiLoading ? t.calculating : t.aiCoach}
               </button>

               {matchCommentary && (
                 <div className="mb-4 bg-indigo-900/30 border border-indigo-500/30 p-3 rounded-xl animate-fade-in">
                   <p className="text-slate-200 italic text-sm">"{matchCommentary}"</p>
                 </div>
               )}

               <div className="mb-6">
                  <button onClick={recordMatchResult} disabled={!selectedTeamA || !selectedTeamB} className="w-full bg-lime-400 hover:bg-lime-500 text-slate-900 font-bold py-4 rounded-xl text-lg shadow-[0_0_20px_rgba(163,230,53,0.3)] transition-all flex items-center justify-center gap-2">
                    <Save size={20}/> {t.saveMatch}
                  </button>
               </div>

               {/* Matches Played Today Section */}
               {todaysMatches.length > 0 && (
                 <div className="mt-8 pt-6 border-t border-slate-800">
                   <h4 className="text-sm font-bold text-slate-400 uppercase tracking-wider mb-4">{t.todaysMatches}</h4>
                   <div className="space-y-3">
                     {todaysMatches.map((m) => (
                       <div key={m.id} className="bg-slate-800/30 p-3 rounded-xl border border-slate-800 flex flex-col gap-2">
                          <div className="flex justify-between items-center text-sm">
                             <span className={`font-bold ${m.winner === 'A' ? 'text-lime-400' : 'text-slate-300'}`}>{m.teamA}</span>
                             <span className="font-mono bg-slate-900 px-2 rounded text-white text-xs py-0.5">{m.scoreA} - {m.scoreB}</span>
                             <span className={`font-bold ${m.winner === 'B' ? 'text-lime-400' : 'text-slate-300'}`}>{m.teamB}</span>
                          </div>
                          <div className="flex justify-between items-center">
                             <span className="text-[10px] text-slate-500 font-mono">{m.timestamp}</span>
                             <span className="text-[10px] text-slate-600 italic truncate max-w-[120px]">{m.name}</span>
                          </div>
                       </div>
                     ))}
                   </div>
                 </div>
               )}

            </div>
          </div>
        )}

        {/* SETTINGS */}
        {currentView === 'settings' && (
          <div className="animate-fade-in">
            <h2 className="text-2xl font-bold text-white mb-6">{t.settings}</h2>
            <div className="bg-slate-900 rounded-2xl border border-slate-800 overflow-hidden mb-6">
              
              {/* Account Section */}
              <div className="p-4 border-b border-slate-800 bg-slate-800/20">
                 <div className="flex items-center gap-3 mb-2">
                    <div className="w-10 h-10 rounded-full bg-lime-500/10 flex items-center justify-center text-lime-400">
                       <Cloud size={20} />
                    </div>
                    <div>
                       <div className="text-white font-bold">{t.account}</div>
                       <div className="text-lime-400 text-xs flex items-center gap-1"><Check size={10} strokeWidth={4}/> {t.cloudSync}</div>
                    </div>
                 </div>
                 {user && (
                   <div className="mt-2 text-xs text-slate-500 font-mono bg-slate-950 p-2 rounded">
                      ID: {user.uid.substring(0, 12)}...
                   </div>
                 )}
                 <button onClick={handleLogout} className="mt-3 w-full bg-red-500/10 hover:bg-red-500/20 text-red-400 text-xs py-2 rounded font-bold flex items-center justify-center gap-2 transition-colors">
                    <LogOut size={12}/> {t.logout}
                 </button>
              </div>

              {/* Language Selector */}
              <div className="p-4 border-b border-slate-800">
                  <div className="flex items-start gap-3 mb-3">
                     <div className="w-10 h-10 rounded-full bg-blue-500/10 flex items-center justify-center text-blue-400">
                        <Globe size={20} />
                     </div>
                     <div>
                        <div className="text-white font-bold">{t.language}</div>
                     </div>
                  </div>
                  <div className="flex gap-2 flex-wrap">
                     {LANGUAGES.map(lang => (
                       <button 
                         key={lang.code}
                         onClick={() => changeLanguage(lang.code)}
                         className={`flex-1 py-2 px-3 rounded-lg text-sm font-bold border transition-all ${language === lang.code ? 'bg-blue-500 text-white border-blue-500' : 'bg-slate-800 text-slate-400 border-slate-700 hover:border-slate-500'}`}
                       >
                         {lang.label}
                       </button>
                     ))}
                  </div>
              </div>

              <div className="p-4 border-b border-slate-800 flex items-center justify-between">
                <div className="text-white font-medium">{t.hideRatings}</div>
                <button onClick={() => {
                   const newState = !settings.hideRatings;
                   setSettings({...settings, hideRatings: newState});
                   setDoc(doc(db, 'users', user.uid, 'settings', 'config'), { ...settings, hideRatings: newState }, { merge: true });
                }} className={`w-12 h-6 rounded-full transition-colors relative ${settings.hideRatings ? 'bg-lime-500' : 'bg-slate-700'}`}><div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-all ${settings.hideRatings ? 'left-7 rtl:right-7 rtl:left-auto' : 'left-1 rtl:right-1 rtl:left-auto'}`}></div></button>
              </div>
              <div className="p-4 flex items-center justify-between">
                <div className="text-white font-medium">{t.useTiers}</div>
                <button onClick={() => {
                   const newState = !settings.useTiers;
                   setSettings({...settings, useTiers: newState});
                   setDoc(doc(db, 'users', user.uid, 'settings', 'config'), { ...settings, useTiers: newState }, { merge: true });
                }} className={`w-12 h-6 rounded-full transition-colors relative ${settings.useTiers ? 'bg-lime-500' : 'bg-slate-700'}`}><div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-all ${settings.useTiers ? 'left-7 rtl:right-7 rtl:left-auto' : 'left-1 rtl:right-1 rtl:left-auto'}`}></div></button>
              </div>
              <div className="p-4 flex items-center justify-between">
                  <button 
                    onClick={() => setIsTutorialOpen(true)} 
                    className="text-lime-400 font-bold text-sm flex items-center gap-2 hover:text-lime-300"
                  >
                    <HelpCircle size={16} /> {t.replayTutorial}
                  </button>
              </div>
            </div>
            
            <div className="text-center text-xs text-slate-600 pb-8">
               Version 2.0 (Cloud Edition)
            </div>
          </div>
        )}
      </main>

      {/* BOTTOM NAV */}
      <div className="fixed bottom-0 left-0 right-0 bg-slate-900 border-t border-slate-800 p-4 pb-6 safe-area-pb shadow-2xl z-40">
        <div className="max-w-2xl mx-auto flex gap-4">
          {currentView === 'roster' && (
            <button onClick={() => { setEditingPlayer(null); setIsModalOpen(true); }} className="w-full bg-lime-400 hover:bg-lime-500 text-slate-900 font-bold py-4 rounded-xl text-lg shadow-[0_0_20px_rgba(163,230,53,0.3)] transition-all flex items-center justify-center gap-2">
              <Plus size={20} strokeWidth={3} /> {t.addPlayer}
            </button>
          )}
          {currentView === 'setup' && (
            <div className="w-full flex flex-col gap-3">
              <div className="flex bg-slate-800 p-1 rounded-lg">
                  {[2, 3, 4].map(num => (
                    <button key={num} onClick={() => setNumTeams(num)} className={`flex-1 py-2 text-sm font-bold rounded-md transition-all ${numTeams === num ? 'bg-slate-700 text-white shadow' : 'text-slate-500 hover:text-slate-300'}`}>{num}</button>
                  ))}
              </div>
              <button onClick={handleGenerateClick} disabled={selectedPlayerIds.size < numTeams || animating} className="w-full bg-lime-400 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-lime-500 text-slate-900 font-bold py-4 rounded-xl text-lg shadow-[0_0_20px_rgba(163,230,53,0.3)] transition-all flex items-center justify-center gap-2">
                {animating ? <RefreshCcw className="animate-spin" /> : <Trophy size={20} strokeWidth={3} />} {animating ? t.calculating : t.generate}
              </button>
            </div>
          )}
          {currentView === 'results' && (
            <div className="w-full flex gap-3">
              <button onClick={() => setCurrentView('setup')} className="flex-1 bg-slate-800 hover:bg-slate-700 text-white font-bold py-4 rounded-xl transition-colors"><ChevronIcon size={24} className="rotate-180"/></button>
              <button onClick={() => handleGenerateClick()} className="flex-1 bg-slate-800 hover:bg-slate-700 text-white font-bold py-4 rounded-xl transition-colors flex items-center justify-center gap-2"><RefreshCcw size={18} /></button>
              <button onClick={copyToClipboard} className="flex-[1] bg-slate-800 hover:bg-slate-700 text-white font-bold py-4 rounded-xl transition-colors flex items-center justify-center"><ClipboardList size={18}/></button>
              <button onClick={shareViaWhatsApp} className="flex-[1.5] bg-green-500 hover:bg-green-600 text-white font-bold py-4 rounded-xl shadow-[0_0_20px_rgba(34,197,94,0.3)] transition-all flex items-center justify-center gap-2"><MessageCircle size={18} /></button>
            </div>
          )}
          {currentView === 'settings' && (
            <button onClick={() => setCurrentView('roster')} className="w-full bg-slate-800 hover:bg-slate-700 text-white font-bold py-4 rounded-xl transition-colors">Done</button>
          )}
          {currentView === 'history' && (
            <button onClick={() => setCurrentView('roster')} className="w-full bg-slate-800 hover:bg-slate-700 text-white font-bold py-4 rounded-xl transition-colors">Back to Roster</button>
          )}
          {currentView === 'leaderboard' && (
            <button onClick={() => setCurrentView('roster')} className="w-full bg-slate-800 hover:bg-slate-700 text-white font-bold py-4 rounded-xl transition-colors">Back to Roster</button>
          )}
        </div>
      </div>

      <PlayerModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onSave={handleSavePlayer} playerToEdit={editingPlayer} t={t} />
      <TutorialModal isOpen={isTutorialOpen} onClose={() => setIsTutorialOpen(false)} />
      <UnevenTeamsModal isOpen={showUnevenPrompt} count={selectedPlayerIds.size} numTeams={numTeams} onClose={() => setShowUnevenPrompt(false)} onConfirm={handleUnevenConfirmation} t={t} />
      <ComingSoonModal isOpen={isComingSoonOpen} onClose={() => setIsComingSoonOpen(false)} />
      <ChemistryModal isOpen={isChemOpen} onClose={() => setIsChemOpen(false)} players={players} matchHistory={matchHistory} t={t} />
      
      {/* Profile Modal */}
      <PlayerProfileModal isOpen={!!profilePlayer} onClose={() => setProfilePlayer(null)} player={profilePlayer} t={t} />

      <style>{`
        @keyframes fade-in { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } } 
        @keyframes bounce-in { 0% { transform: translate(-50%, -100%); } 60% { transform: translate(-50%, 10%); } 100% { transform: translate(-50%, 0); } }
        .animate-fade-in { animation: fade-in 0.3s ease-out forwards; } 
        .animate-bounce-in { animation: bounce-in 0.4s cubic-bezier(0.68, -0.55, 0.27, 1.55) forwards; }
        .safe-area-pb { padding-bottom: env(safe-area-inset-bottom, 24px); }
      `}</style>
    </div>
  );
}